export default __webpack_public_path__ + "static/media/CMS_Price group.68b71e0f.svg";